import {Link, Typography} from "@mui/material";
import {documents, FOOTER_DATA} from "../constants";

const FooterData = () => {
  return (
    <>
      <Typography
        variant="caption2"
        sx={{
          display: 'block',
          textAlign: 'center',
          marginBottom: {xxs: 2, md: 0},
          mr: {md: 3}
        }}
      >
        {FOOTER_DATA.copyright}
      </Typography>
      {documents.map((document, index) => (
        <Typography
          key={index}
          variant="caption2"
          component={Link}
          href={document.href}
          target="_blank"
          download={true}
          sx={{
            display: 'block',
            textAlign: 'center',
            marginBottom: {xxs: 2, md: 0},
            mr: {md: 3},
            color: 'red.500',
            textDecoration: 'none'
          }}
        >
          {document.text}
        </Typography>
      ))}
    </>
  )
}

export default FooterData;
